<template>

    <div class="market__container">

        <h1 class="market__title">{{ card.title }}</h1>

        <p class="market__subtitle">{{ card.subtitle }}</p>

        <button class="btn btn-dark btn-big market__btn" @click="goLink">

            {{ $t('marketing_card_cta') }}

            <img class="market__img" src="/img/icons/external-link-white.svg">

        </button>

    </div>

</template>

<script>

import Tag from '@/modules/tag'

export default {

    name: 'card-template-market',

    props: {

        card: {
            type: Object,
            default: {}
        },

        position: {
            type: Number,
            default: -1
        }
    },

    watch: {

        position: function (position) {
            if (position === 1) {

                Tag.pageViewGA(this, this.card.tag)
            }
        }
    },

    methods: {

        goLink() {

            Tag.clickGA(this, 'card_marketing', this.card.tag)

            window.open(this.card.cta, '_blank', 'rel="noopener,noreferrer,nofollow"')

        }
    }
}

</script>

<style lang="scss" scoped>

.market {

    &__container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        flex-direction: column;
        padding: 40px 24px 24px;
        background-color: $aquamarine;
        color: $white;
        border-radius: 12px;
        background-image: url("/img/background/cards-market.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
    }

    &__title {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
    }

    &__subtitle {
        margin-top: 8px;
        display: flex;
        flex-grow: 1;
        font-size: 17px;
        line-height: 1.29;
        justify-content: center;
    }

    &__btn {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
    }

    &__img {
        width: 24px;
        object-fit: contain;
        margin-left: 8px;
    }
}

</style>
